import { useSelector } from 'react-redux';

import { selectGatewayLegend } from '@lib/redux/slices/walletSlice';
import useWallet from '@lib/hooks/useWallet';

import Stack from '@components/Stack';
import Typography from '@components/Typography';

const GatewayLegend: React.FC = () => {
    // The legend lives on the Redux wallet slice (populated by the checkout flow), but
    // the account Manage Payments / Add Payment screens fetch the wallet through the
    // legacy zustand store. Fall back to the zustand copy so the label shows on those
    // screens too, without a session first passing through checkout (JSAD-6881). Redux
    // wins when both are set so the checkout flow stays authoritative.
    const reduxLegend = useSelector(selectGatewayLegend);
    const { gatewayLegend: zustandLegend } = useWallet();
    const legend = reduxLegend ?? zustandLegend;

    if (!legend) {
        return null;
    }

    return (
        <Stack alignItems="center" sx={{ sm: { marginTop: 12, paddingHorizontal: 16 } }}>
            <Typography variant="p5" center testID="gateway-legend">
                {legend}
            </Typography>
        </Stack>
    );
};

export default GatewayLegend;
